import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl } from "../../api/common";
import { showToast, ToastMessage } from "../Shared/ToastMessage";

const AddAdminUserComponent = ({ fetchAdminUsersData, addPopupStatus, handleAddPopup, eventType, updateData }) => {

  const [updateId, setUpdateId] = useState("");

  const [formValues, setFormValues] = useState({
    full_name: "",
    email: "",
    role: "",
  });

  const [errors, setErrors] = useState({
    full_name: "",
    email: "",
    role: ""
  });

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const validate = () => {
    const newErrors = {
      full_name: "",
      email: "",
      role: ""
    };

    if (!formValues.full_name.trim()) {
      newErrors.full_name = "Name cannot be empty";
    }

    if (!formValues.email.trim()) {
      newErrors.email = "Email cannot be empty";
    } else if (!/^\S+@\S+\.\S+$/.test(formValues.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formValues.role) {
      newErrors.role = "Role cannot be empty";
    }

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const clearInputValues = () => {
    setErrors({
      full_name: "",
      email: "",
      role: ""
    });
    setFormValues({
      full_name: "",
      email: "",
      role: ""
    }); 
    handleAddPopup(false);
  };

  const [adminRolesData, setAdminRolesData] = useState([]);

  const fetchAdminRolesData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_role`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });

      if (response.data.status) {
        setAdminRolesData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const addUpdateAdminUserRole = async () => {
    if (validate()) {
      console.log("Post Data:", formValues);
      try {
        const requestData = {
          ...formValues,
          login_user_id: localStorage.getItem("loginUserId"),
          ...(eventType === "Update" && { id: updateId }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(`${baseUrl}/api/add_user`, requestData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: localStorage.getItem("access_token"),
          },
        });

        if (response.data.status) {
          showToast(response.data.message, "success");
          fetchAdminUsersData();
          clearInputValues();
        } else {
          showToast(response.data.message, "error");
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Submission failed. Please try again.", "error");
      }
    }
  };

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      setUpdateId(updateData.id);
      setFormValues({
        full_name: updateData.full_name || "",
        email: updateData.email || "",
        role: updateData.role || ""
      });
    } else {
      setErrors({
        full_name: "",
        email: "",
        role: ""
      });
      setFormValues({
        full_name: "",
        email: "",
        role: ""
      });
    }

    fetchAdminRolesData();
  }, [eventType, updateData, addPopupStatus]);

  return (
    <>
      <ToastMessage />
      {addPopupStatus && (
      <div className={`extraspace_search_div search_div open`}>
        <div className="card member_master_sidebar_scrool">
          <div className="member_edit_pop_flex mb-3 text-end">
            <h3>Add User</h3>
            <div className="input-group-append">
              <span onClick={clearInputValues} className="search_toggle btn btn-danger">
                <i className="fa fa-times" />
              </span>
            </div>
          </div>
          <div className="table-responsive">
            <div className="body application_body_side">
              <fieldset>
                <div className="row clearfix">
                  <div className="col-md-6">
                    <div className="form-group pos_relative">
                      <label>Name</label>
                      <input
                        type="text"
                        className={`form-control ${errors.full_name ? "red_border" : ""}`}
                        value={formValues.full_name}
                        onChange={(e) => handleInputChange("full_name", e.target.value)}
                      />
                      {errors.full_name && <p className="text-danger pos_abos">{errors.full_name}</p>}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group pos_relative">
                      <label>Email</label>
                      <input
                        type="text"
                        className={`form-control ${errors.email ? "red_border" : ""}`}
                        value={formValues.email}
                        onChange={(e) => handleInputChange("email", e.target.value)}
                      />
                      {errors.email && <p className="text-danger pos_abos">{errors.email}</p>}
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group pos_relative">
                      <label>Role</label>
                      <select
                        className={`form-control ${errors.role ? "red_border" : ""}`}
                        value={formValues.role}
                        onChange={(e) => handleInputChange("role", e.target.value)}
                      >
                        <option value="">-- Select Role --</option>
                        {adminRolesData.length > 0 ? (
                          adminRolesData.map((data) => (
                            <option key={data.id} value={data.id.toString()}>
                              {data.role_name}
                            </option>
                          ))
                        ) : (
                          <option disabled>No data available</option>
                        )}
                      </select>
                      {errors.role && <p className="text-danger pos_abos">{errors.role}</p>}
                    </div>
                  </div>

                  {/* <div className="col-md-12 pt-5 pb-3">
                    <div className="last_form_submit_flex">
                      <button onClick={clearInputValues} className="btn btn-outline-info btn-block saveand_proced_button" type="button">
                        Back
                      </button>
                      <button onClick={addUpdateAdminUserRole} className="btn btn-outline-success btn-block saveand_proced_button" type="button">
                        Save & Proceed
                      </button>
                    </div>
                  </div> */}
                    <div className="col-md-12 member_button_flex">
                      <button onClick={() => addUpdateAdminUserRole()} className="btn btn-outline-info">
                      {eventType}
                      </button>
                      <a
                        onClick={() => clearInputValues()}
                        className="btn btn-outline-danger"
                      >
                        Close
                      </a>
                    </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default AddAdminUserComponent;
